<template>
  <DetailsPane
    :title="title || course.name"
    :hide-title="hideTitle"
    :tabs="tabs"
    :current-tab="currentTab"
    :hide-close="hideClose"
    :height="height"
    :auto-height="autoHeight"
    @show-tab="showTab"
    @close="$emit('close')"
  >
    <DetailsTab
      slot="tab-details"
      :course="course"
      :enrollment="enrollment"
      :details-url="detailsUrl"
      :hide-description="hideDescription"
      :hide-enroll-buttons="hideEnrollButtons"
      :hide-launch-button="hideLaunchButton"
    />
    <TrainerTab slot="tab-trainer" :course="course" />
    <EventsTab slot="tab-events" :course="course" />
    <DownloadsTab slot="tab-downloads" :course="course" />
    <FeedbackTab slot="tab-feedback" :course="course" />
  </DetailsPane>
</template>

<script>
import DetailsPane from "components/listings/DetailsPane";
import DetailsPaneMixin from "mixins/DetailsPane";
import DetailsTab from "./DetailsPaneTabs/Details";
import TrainerTab from "./DetailsPaneTabs/Trainer";
import EventsTab from "./DetailsPaneTabs/Events";
import DownloadsTab from "./DetailsPaneTabs/Downloads";
import FeedbackTab from "./DetailsPaneTabs/Feedback";

export default {
  mixins: [DetailsPaneMixin],
  components: {
    DetailsPane,
    DetailsTab,
    TrainerTab,
    EventsTab,
    DownloadsTab,
    FeedbackTab,
  },
  props: {
    course: { type: Object, required: true },
    enrollment: { type: Object },
    tab: { type: String, default: "details" },
    section: { type: String, default: "registration" },
    hideDescription: { type: Boolean, default: false },
    hideEnrollButtons: { type: Boolean, default: false },
    hideLaunchButton: { type: Boolean, default: false },
  },
  data() {
    return {
      currentTab: "details",
    };
  },
  computed: {
    tabs() {
      let tabs = [];
      tabs.push({
        key: "details",
        label: "Details",
        icon: "details",
        ga_category: "Course",
        ga_label: this.course.name,
        ga_value: this.course.id,
      });
      if (!!this.course.show_trainer_bio) {
        tabs.push({
          key: "trainer",
          label: "Trainer",
          icon: "trainer",
          ga_category: "Course",
          ga_label: this.course.name,
          ga_value: this.course.id,
        });
      }
      if (!!this.course.is_classroom) {
        tabs.push({
          key: "events",
          label: "Events",
          icon: "events",
          ga_category: "Course",
          ga_label: this.course.name,
          ga_value: this.course.id,
        });
      }
      if (!!this.course.show_downloads) {
        tabs.push({
          key: "downloads",
          label: "Downloads",
          icon: "download",
          ga_category: "Course",
          ga_label: this.course.name,
          ga_value: this.course.id,
        });
      }
      if (!!this.course.show_rating) {
        tabs.push({
          key: "feedback",
          label: "Reviews",
          icon: "star",
          ga_category: "Course",
          ga_label: this.course.name,
          ga_value: this.course.id,
        });
      }
      return tabs;
    },
    routeParam() {
      return { course: this.course.id };
    },
    detailsUrl() {
      if (this.section == "admin") {
        return this.route("admin.courses.edit", this.routeParam);
      } else if (this.section == "training") {
        return this.route("training.courses.show", this.routeParam);
      } else {
        return this.route("catalog.course", this.routeParam);
      }
    },
  },
  watch: {
    tab(val) {
      this.currentTab = val;
    },
  },
  methods: {
    showTab(tab) {
      this.currentTab = tab;
    },
  },
  created() {
    this.currentTab = this.tab || "details";
  },
};
</script>
